import { Component, HostListener, OnInit } from '@angular/core';
import { UtilsService } from 'app/services/utils.service';
import { environment } from 'environments/environment';
import { TransactionFilter } from 'app/models/TransactionFilter';
import { TransactionReportOutput } from 'app/models/TransactionReportOutput';

// 
@Component({
	selector: 'vbn-kiosk-reports',
	templateUrl: './kiosk-reports.component.html',
	styleUrls: ['./kiosk-reports.component.scss']
})
export class KioskReportsComponent implements OnInit {

	transactionFilter: TransactionFilter;
	transactionReportOutput: TransactionReportOutput;
	pageNumber: number;
	itemPerPage: number = 15;
	configPagination: any;
	isOnResponsive: boolean = false;
	selectedClient: string;
	errorMessage: string;
	selectedTab = 1;
	transactionStatus: string = undefined;
	startDate: Date;
	endDate: Date;
	requiredField: boolean = false;
	isLoading: boolean = false;

	constructor(private service: UtilsService) {
		this.transactionFilter = new TransactionFilter();
		this.transactionReportOutput = new TransactionReportOutput();
	}

	ngOnInit() {
		this.selectedClient = this.service.currentUserEmail;
	}

	selectTab(tabNumber: number): void {
		this.selectedTab = tabNumber;
		this.resetFilters();
	}

	resetFilters() {
		this.transactionFilter = new TransactionFilter();
		this.transactionReportOutput = new TransactionReportOutput();
		this.transactionStatus = undefined;
		this.startDate = undefined;
		this.endDate = undefined;
		this.requiredField = false;
	}

	checkRequiredFields() {
		if (this.startDate == undefined || this.endDate == undefined) {
			this.requiredField = true;
		} else {
			this.requiredField = false;
		}
		return this.requiredField;
	}

	applyFilters() {
		if (this.checkRequiredFields()) {
			return;
		}
		this.transactionFilter.clientEmail = this.selectedClient;
		this.transactionFilter.startDate = this.startDate;
		this.transactionFilter.endDate = this.endDate;
		if (this.transactionStatus !== undefined) {
			this.transactionFilter.success = new Boolean(this.transactionStatus);
		}
		const params = this.transactionFilter.toQueryString();

		let url = "";
		switch (this.selectedTab) {
			case 1:
				url = `/transaction/getTransactionsNumberByFilters?${params}`;
				break;
			case 2:
				url = `/transaction/getTransactionsAmountByFilters?${params}`;
				break;
			case 3:
				url = `/transaction/getTransactionsTypeByFilters?${params}`;
				break;
			case 4:
				url = `/transaction/getTransactionsNumberPerKioskByFilters?${params}`;
				break;
		}
		this.isLoading = true;
		this.service.get(environment.taxesAndFeesURL + url)
			.subscribe(
				response => {
					this.transactionReportOutput = response;
					this.isLoading = false;
				},
				error => {
					this.isLoading = false;
					this.errorMessage = <any>error
				}
			);
	}
	exportResults() {
		if (this.checkRequiredFields()) {
			return;
		}
		this.transactionFilter.clientEmail = this.selectedClient;
		this.transactionFilter.startDate = this.startDate;
		this.transactionFilter.endDate = this.endDate;
		if (this.transactionStatus !== undefined) {
			this.transactionFilter.success = new Boolean(this.transactionStatus);
		}
		const params = this.transactionFilter.toQueryString();

		let url = "";
		switch (this.selectedTab) {
			case 1:
				url = `/transaction/exportTransactionsNumberByFilters?${params}`;
				break;
			case 2:
				url = `/transaction/exportTransactionsAmountByFilters?${params}`;
				break;
			case 3:
				url = `/transaction/exportTransactionsTypeByFilters?${params}`;
				break;
			case 4:
				url = `/transaction/exportTransactionsNumberPerKioskByFilters?${params}`;
				break;
		}
		this.isLoading = true;
		this.service.downloadFile(environment.taxesAndFeesURL + url)
			.subscribe(
				response => {
					const blob = new Blob([response.body], { type: response.body.type });

					const link = document.createElement('a');
					link.href = window.URL.createObjectURL(blob);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					this.isLoading = false;
				},
				error => {
					this.isLoading = false;
					this.errorMessage = <any>error
				});
	}

}
